import React from 'react';

function FormHeader({config}) {
  // No renderizar el contenedor si no hay logo ni nombre de cliente
  if (!config.clientLogo && !config.clientName) {
    return null;
  }

  return (
    <div className="flex flex-col items-center justify-center my-4">
      {config.clientLogo ? (
        <img src={config.clientLogo} alt="Client Logo" className="h-12 sm:h-16 max-w-full object-contain" />
      ) : config.clientName ? (
        <h2 className="text-lg sm:text-xl font-bold text-center uppercase">
          {config.clientName}
        </h2>
      ) : null}
    </div>
  );
}

export default FormHeader;